setPmScreenProcessingAction